#import "../fragments/chat-agent-fragment.graphql"

query GetAgents {
    chatAgents {
        ...ChatAgent
    }
}
